function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  & > * {\n    ", ";\n  }\n  & > *:first-child {\n    line-height: ", "px;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n        border: 0;\n        clip: rect(0 0 0 0);\n        height: 1px;\n        width: 1px;\n        margin: -1px;\n        padding: 0;\n        overflow: hidden;\n        position: absolute;\n      "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          border: ", " solid\n            ", ";\n          &:before {\n            left: 2px;\n            ", ";\n          }\n          &:focus,\n          &:active {\n            border-color: ", ";\n          }\n          &:disabled {\n            border-color: ", ";\n            background-color: ", ";\n          }\n        "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n      &:disabled {\n        border-color: ", "\n        background-color: ", ";\n      }\n      &:disabled:after {\n        opacity: 1;\n      }\n      ", ";\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n              background-color: ", ";\n            "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n          border-color: ", ";\n\n          &::before {\n            color: ", ";\n          }\n\n          &:focus,\n          &:active,\n          &:hover:not(:disabled) {\n            border-color: ", ";\n          }\n\n          ", ";\n        "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          border-color: ", ";\n          color: ", ";\n\n          &::before {\n            color: ", ";\n          }\n\n          &:focus,\n          &:active,\n          &:hover:not(:disabled) {\n            border-color: ", ";\n          }\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n      cursor: pointer;\n\n      &::before {\n        content: '", "';\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        ", "\n        padding: 0 ", "px;\n      }\n\n      &:hover:not(:disabled) {\n        border-color: ", ";\n        background-color: ", ";\n      }\n\n      ", ";\n\n      ", ";\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n\n      &:focus,\n      &:active {\n        border-color: ", ";\n      }\n\n      ", ";\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n\n      &:focus,\n      &:active {\n        border-color: ", ";\n      }\n      &:disabled {\n        border-color: ", "\n        background-color: ", ";\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", "px;\n  border: ", " solid ", ";\n  border-radius: ", ";\n  appearance: none;\n  background-color: ", ";\n  position: relative;\n  outline: none;\n  margin: 0;\n  transition: all ease-in-out 0.2s;\n  \n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:focus,\n  &:active {\n    ", ";\n  }\n\n  &::before,\n  &::after {\n    margin: auto;\n    content: '';\n    display: block;\n    position: absolute;\n  }\n\n  &::after {\n    opacity: 0;\n    /* prettier-ignore */\n    ", " \n    ", " \n    ", "\n  }\n\n  ", "\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n    ", "\n};\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: ", "px;\n  height: ", "px;\n  transform: translateX(-50%);\n  transition: transform ease-in-out ", ",\n    opacity ease-in-out ", ";\n  border-radius: 100%;\n  opacity: 1;\n  background-color: ", ";\n  border: ", " solid ", ";\n\n  /* prettier-ignore */\n  ", "\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      opacity: 1;\n      transform: translateX(50%);\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    opacity: 1;\n    transform: scale(1);\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  transform: scale(0.5);\n  transition: transform ease-in-out ", ",\n    opacity ease-in-out ", ";\n  border-radius: 100%;\n\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    opacity: 1;\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  transition: transform ease-in-out ", ",\n    opacity ease-in-out ", ";\n\n  ", " ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  background: url(\"data:image/svg+xml,", "\")\n    no-repeat center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  user-select: none;\n  align-items: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { BorderWidth, CircleFontsForSizes, TRANSITION_TIME, Types } from './constants';
import { Spacing, encodeIconSVG, getFocusStyles, themedFontFamily } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import CheckmarkIcon from './CheckmarkIcon';
import React from 'react';
export var ToggleContainer = styled.div(_templateObject(), function (props) {
  return props.alignment;
});

var encodedCheckStyling = function encodedCheckStyling(size, isDisabled, colors) {
  return css(_templateObject2(), size, size, encodeIconSVG(React.createElement(CheckmarkIcon, {
    size: size,
    fillColor: isDisabled ? colors.toggleForegroundOnDisabled : colors.toggleForegroundOn
  })));
};

var memoizedCheckStyling = function memoizedCheckStyling() {
  var checkStylingCache = {};
  return function (size, isDisabled, colors) {
    if (checkStylingCache.hasOwnProperty("".concat(size, "-").concat(isDisabled))) {
      return checkStylingCache["".concat(size, "-").concat(isDisabled)];
    }

    var result = encodedCheckStyling(size, isDisabled, colors);
    checkStylingCache["".concat(size, "-").concat(isDisabled)] = result;
    return result;
  };
};

var checkStyling = memoizedCheckStyling();
/**
 * makeCheck
 * Returns background checkmark styling using DLS `Check` Icon
 * to indicate "on" state for certain kinds of Toggle switches
 * @param {number} size
 * @param {boolean} isDisabled
 * @param {object} colors
 */

var makeCheck = function makeCheck(size, isDisabled, colors) {
  return checkStyling(size, isDisabled, colors);
};
/**
 * check
 * Checkmark CSS fragment for use as a pseudo-element in Checkmark
 */


export var check = css(_templateObject3(), TRANSITION_TIME, TRANSITION_TIME, // prettier-ignore
function (props) {
  return makeCheck(props.size, props.disabled, props.colors);
}, // prettier-ignore
function (props) {
  return props.checked && css(_templateObject4(), makeCheck(props.size, props.disabled, props.colors));
});
/**
 * circle
 * Radio CSS fragment for use as a pseudo-element in RadioButton
 */

export var circle = css(_templateObject5(), function (props) {
  return props.size / 2;
}, function (props) {
  return props.size / 2;
}, function (props) {
  if (props.kind === Types.Radio) {
    if (props.disabled) {
      return props.colors.toggleBorderOnDisabled;
    }

    if (props.error) {
      return props.colors.error;
    }
  }

  if (props.disabled) {
    return props.colors.toggleBackgroundOnDisabled;
  }

  return props.colors.toggleBackgroundOn;
}, TRANSITION_TIME, TRANSITION_TIME, // prettier-ignore
function (props) {
  return props.checked && css(_templateObject6());
});
/**
 * toggle
 * Toggle circle CSS fragment for use as a pseudo-element in Toggle
 */

var getToggleBorderColor = function getToggleBorderColor(props) {
  if (props.disabled) {
    if (props.checked) {
      return props.colors.toggleBorderOnDisabled;
    }

    return props.colors.toggleBorderOffDisabled;
  }

  if (props.error) {
    return props.colors.error;
  }

  if (props.checked) {
    return props.colors.toggleBorderOn;
  }

  return props.colors.toggleBorderOff;
};

var getToggleCheckedStyles = function getToggleCheckedStyles(props) {
  if (props.checked) {
    return css(_templateObject7());
  }

  return null;
};

var getToggleErrorStyles = function getToggleErrorStyles(props) {
  if (props.error) {
    // prettier-ignore
    return css(_templateObject8(), props.colors.error);
  }

  return null;
};

var getFontStylesFromCircleSize = function getFontStylesFromCircleSize(circleSize) {
  var fontObj = CircleFontsForSizes[circleSize];
  return "\n    font-size: ".concat(fontObj.size, "px;\n    font-family: ").concat(themedFontFamily(fontObj.themeFontFamily), ";\n    color: ").concat(fontObj.color, ";\n    font-weight: ").concat(fontObj.weight, ";\n    line-height: ").concat(fontObj.lineHeight, ";\n    letter-spacing: ").concat(fontObj.letterSpacing, ";\n    text-transform: ").concat(fontObj.textTransform, ";\n  ");
};

export var toggle = css(_templateObject9(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, TRANSITION_TIME, TRANSITION_TIME, function (props) {
  return props.disabled ? props.colors.toggleForegroundOnDisabled : props.colors.toggleForegroundOn;
}, BorderWidth, getToggleBorderColor, getToggleCheckedStyles, getToggleErrorStyles);
export var ToggleInput = styled.input(_templateObject10(), function (props) {
  return props.kind === Types.Toggle ? "".concat(props.size * 2, "px") : "".concat(props.size, "px");
}, function (props) {
  return props.size;
}, function (props) {
  return props.kind === Types.Circle ? '1px' : BorderWidth;
}, getToggleBorderColor, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.colors.toggleBackgroundOff;
}, function (props) {
  return props.colors.toggleBorderOffDisabled;
}, function (props) {
  return props.colors.toggleBackgroundOffDisabled;
}, getFocusStyles(), function (props) {
  return props.kind === Types.Checkbox && check;
}, function (props) {
  return props.kind === Types.Radio && circle;
}, function (props) {
  return props.kind === Types.Toggle && toggle;
}, function (props) {
  return props.checked && css(_templateObject11(), props.colors.toggleBorderOn, props.kind === Types.Radio ? props.colors.toggleBackgroundOff : props.colors.toggleBackgroundOn, props.colors.toggleBorderOn, props.colors.toggleBorderOnDisabled, props.kind === Types.Radio ? props.colors.toggleBackgroundOffDisabled : props.colors.toggleBackgroundOnDisabled);
}, function (props) {
  return props.error && css(_templateObject12(), props.colors.error, props.colors.toggleBackgroundOff, props.colors.error, props.checked && css(_templateObject13(), props.kind === Types.Radio ? props.colors.toggleBackgroundOff : props.colors.error));
}, function (props) {
  return props.kind === Types.Circle && css(_templateObject14(), props.colors.buttonSecondaryToggleBackgroundOff, props.colors.buttonSecondaryToggleBorderOff, props.label, getFontStylesFromCircleSize(props.size), Spacing.XxxSmall, props.checked ? props.colors.buttonSecondaryToggleBorderOnHovered : props.colors.buttonSecondaryToggleBorderOffHovered, props.checked ? props.colors.buttonSecondaryToggleBackgroundHovered : props.colors.buttonSecondaryToggleBackgroundOffHovered, props.checked && css(_templateObject15(), props.colors.buttonSecondaryToggleBackground, props.colors.buttonSecondaryToggleBorderOn, props.colors.buttonSecondaryToggleForeground, props.colors.buttonSecondaryToggleForeground, props.colors.buttonSecondaryToggleBorderOnHovered), props.error && css(_templateObject16(), props.colors.error, props.colors.error, props.colors.error, props.checked && css(_templateObject17(), props.colors.buttonSecondaryBackground)));
}, function (props) {
  return props.kind === Types.Toggle && css(_templateObject18(), props.error ? props.colors.error : props.colors.toggleBorderOff, props.colors.toggleBackgroundOff, props.colors.toggleBorderOffDisabled, props.colors.toggleBackgroundOffDisabled, props.checked && css(_templateObject19(), props.error ? props.colors.error : props.colors.toggleBackgroundOn, BorderWidth, props.error ? props.colors.error : props.colors.toggleBorderOn, makeCheck(props.size, props.disabled, props.colors), props.error ? props.colors.error : props.colors.toggleBorderOn, props.colors.toggleBorderOnDisabled, props.colors.toggleBackgroundOnDisabled));
}, function (props) {
  return props.isToggleHidden && css(_templateObject20());
});
export var LabelContainer = styled.div(_templateObject21(), // prettier-ignore
function (props) {
  return props.isDisabled && css(_templateObject22());
}, function (props) {
  return props.size;
});
export var ContentContainer = styled.div(_templateObject23());